import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import { 
  ChartBarIcon, 
  CogIcon,
  ChartPieIcon,
  RocketLaunchIcon,
  PresentationChartLineIcon,
  CursorArrowRaysIcon
} from '@heroicons/react/24/outline';
import { LanguageContext } from '../contexts/LanguageContext';
import { translations } from '../locales/translations';

const Products = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language].productsPage;

  return (
    <div className="min-h-screen pt-16">
      {/* 产品概览 */}
      <section className="bg-gray-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-16"
          >
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              {t.hero.title}
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              {t.hero.subtitle}
            </p>
          </motion.div>

          {/* 产品详情 */}
          {t.products.map((product, index) => (
            <motion.div
              key={product.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              viewport={{ once: true }}
              className={`flex flex-col md:flex-row items-center gap-8 py-16 ${
                index % 2 === 1 ? 'md:flex-row-reverse' : ''
              }`}
            >
              {/* 产品说明 */}
              <div className="flex-1 space-y-6">
                <div className={`w-12 h-12 rounded-lg bg-primary flex items-center justify-center`}>
                  {product.id === 'analytics' && <ChartPieIcon className="w-6 h-6 text-white" />}
                  {product.id === 'advertising' && <CursorArrowRaysIcon className="w-6 h-6 text-white" />}
                  {product.id === 'automation' && <RocketLaunchIcon className="w-6 h-6 text-white" />}
                </div>
                <h2 className="text-3xl font-bold text-gray-900">{product.title}</h2>
                <p className="text-xl text-gray-600">{product.description}</p>
                
                <div className="grid md:grid-cols-2 gap-6 mt-8">
                  {product.features.map((feature, idx) => (
                    <div key={idx} className="space-y-4">
                      <h3 className="text-xl font-semibold text-gray-900">
                        {feature.title}
                      </h3>
                      <ul className="space-y-2">
                        {feature.points.map((point, pidx) => (
                          <li key={pidx} className="flex items-center text-gray-600">
                            <div className="w-2 h-2 bg-primary rounded-full mr-2"></div>
                            {point}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>

              {/* 产品截图 */}
              <div className="flex-1">
                <div className="bg-gray-200 rounded-lg h-80 w-full">
                  <div className="h-full flex items-center justify-center text-gray-500">
                    {language === 'en' ? 'Product Interface' : '产品界面展示'}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* CTA部分 */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">
            {t.cta.title}
          </h2>
          <div className="flex justify-center gap-4">
            <button className="bg-primary text-white px-8 py-3 rounded-lg font-medium hover:bg-blue-600 transition-colors">
              {t.cta.tryFree}
            </button>
            <button className="border-2 border-primary text-primary px-8 py-3 rounded-lg font-medium hover:bg-primary hover:text-white transition-colors">
              {t.cta.bookDemo}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Products;
